import { Component, Input, OnInit } from '@angular/core';
import { TableModule , TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ProjectService } from '../../../../../../shared/services/project.service';
import { CommonModule } from '@angular/common';
import { ResponseProject } from '../response-tab/response.interface';
import { Role } from '../../project.interface';
import { TooltipModule } from 'primeng/tooltip';
import { CompanyService } from '../../../../../../shared/services/company.service';
import { PipesModule } from '../../../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../../../shared/services/helper.service';
import { CommonBaseClass } from '../../../../../../shared/classes/common-base-class';

@Component({
  selector: 'app-details-tab',
  standalone: true,
  imports: [TableModule, ButtonModule, IconFieldModule, InputIconModule, CommonModule, TooltipModule, PipesModule],
  templateUrl: './details-tab.component.html',
  styleUrl: './details-tab.component.scss'
})
export class DetailsTabComponent extends CommonBaseClass implements OnInit {
  @Input() projectId!: any;
  roleDetails!: Role;
  responseData: ResponseProject=[];
  expandedRows:{ [key: string]: boolean }  = {};
  projectDetails:any;
  projectSearchMarkets:string='';
  roleDetailsDisplay!:any;
  companies: any = [];

  constructor(private projectService: ProjectService, private companyService: CompanyService, helperService: HelperService ) {
    super(helperService);
  }

  async ngOnInit() {
    this.getProjectDetails();
    this.getProjectResponse();
    this.companies = await this.companyService.getCompanies();
  }

  getProjectDetails(): void {
    if (this.projectId){
      this.projectService.getProjectById(this.projectId).subscribe({
        next: (resp) => {
          this.projectDetails = resp;
        }
      })
    }
  }

  onRowExpand(event: TableRowExpandEvent) {
    this.projectService.getRoleDetails(this.projectId,event.data._id).subscribe((response)=>{
      this.roleDetails = response;
      this.roleDetailsDisplay = {
        jobType: this.roleDetails?.jobType,
        degrees: this.roleDetails?.degrees,
        graduate: this.roleDetails?.degrees.filter((degree) => degree.graduate),
        underGrad: this.roleDetails?.degrees.filter((degree) => !degree.graduate),
        skillsAndExperience: this.roleDetails?.criteria[0]?.labels?.values,
        credential: this.roleDetails?.credential,
      }
    });
    this.expandedRows = {};
    this.expandedRows[event.data._id] = true;  
  }

  onRowCollapse(event: TableRowCollapseEvent) { }

  displaySearchMarkets(searchMarkets: any[]){
    return searchMarkets.length > 0 ? searchMarkets.map((s:any) => s.name).join(', ') : null;
  }

  getProjectResponse(): void {
    if (this.projectId){
      this.projectService.getProjectResponse(this.projectId).subscribe({
        next: (resp: ResponseProject) => {
          this.responseData = resp;
          if(this.responseData.length){
            this.projectService.getRoleDetails(this.projectId,this.responseData[0]?._id).subscribe((response)=>{
              this.roleDetails = response;
            })  
          }
        }
      })
     }
  }

  /**
   * Delegates to HelperService so the null-hours guard lives in one place; PWC roles carry
   * no working hours and the old local copy rendered them as "0null:0null null".
   */
  formatTime(time: { hour: number, min: number, meridiem: string } | null | undefined): string {
    return this.helperService.formatTime(time);
  }

  captionName(caption: any): string {
    return this.companies.filter((company: any) => company._id === caption)[0]?.name || caption
  }
}
